import React, { Component } from "react";
import PasswordField from "../PasswordField";
import SwitchSlider from "../SwitchSlider";
import styles from "../../../assets/css/modules/myprofile/myprofilecommunicationprefs.css";

export class FormGroup extends Component {
  render() {
    let inputTag;
    let formGroupClass = this.props.className
      ? this.props.className
      : "form-group";

    if (this.props.type === "yesno") {
      if (this.props.Zebrafied) {
        return (
          <div className="zebrafied-form-row">
            <div className="row justify-content-between align-items-center">
            <div className={styles.firstSectionSetWidth}>
                <label htmlFor={this.props.id} className="m-0 align-middle">
                  {this.props.isMyProfileCommPref ?
                  <div className={styles.commNeeds}><strong>{this.props.label}</strong>
                  <br /> {this.props.Subheading[this.props.PreferenceId]}</div>:
                  this.props.label }
                </label>
              </div>
              <div className="col text-right">
                <div className="d-inline-block align-middle">
                  {this.props.UseSlider ? (
                    <SwitchSlider
                      id={this.props.id}
                      onChange={this.props.onChange}
                      currentValue={this.props.currentValue}
                    />
                  ) : (
                    <React.Fragment>
                      <span className="form-group label-normal">
                        <label
                          className="custom-control custom-radio radio2 align-middle"
                          htmlFor={this.props.id + "Yes"}
                        >
                          <input
                            id={this.props.id + "Yes"}
                            name={this.props.id}
                            type="radio"
                            onChange={this.props.onChange}
                            className="custom-control-input"
                            value="true"
                            defaultChecked={this.props.currentValue === true}
                          />
                          <span className="custom-control-description">
                            Yes
                          </span>
                          <span className="custom-control-indicator mr-0 ml-2" />
                        </label>
                        <label
                          className="custom-control custom-radio radio2 align-middle"
                          htmlFor={this.props.id + "No"}
                        >
                          <input
                            id={this.props.id + "No"}
                            name={this.props.id}
                            type="radio"
                            onChange={this.props.onChange}
                            className="custom-control-input"
                            value="false"
                            defaultChecked={this.props.currentValue === false}
                          />
                          <span className="custom-control-description">No</span>
                          <span className="custom-control-indicator mr-0 ml-2" />
                        </label>
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      }
      return (
        <div className={formGroupClass}>
          <label
            className={
              this.props.labelClass
                ? this.props.labelClass
                : "align-middle mb-0 cw-125"
            }
            htmlFor={this.props.id + "Set"}
          >
            {this.props.label}
          </label>
          <span className="form-group label-normal">
            <fieldset id={this.props.id + "Set"}>
              <label
                className="custom-control custom-radio radio2 align-middle"
                htmlFor={this.props.id + "Yes"}
              >
                <input
                  id={this.props.id + "Yes"}
                  name={this.props.id}
                  type="radio"
                  onChange={this.props.onChange}
                  className="custom-control-input"
                  value="true"
                  defaultChecked={this.props.currentValue === true}
                />
                <span className="custom-control-description">Yes</span>
                <span className="custom-control-indicator mr-0 ml-2" />
              </label>
              <label
                className="custom-control custom-radio radio2 align-middle"
                htmlFor={this.props.id + "No"}
              >
                <input
                  id={this.props.id + "No"}
                  name={this.props.id}
                  type="radio"
                  onChange={this.props.onChange}
                  className="custom-control-input"
                  value="false"
                  defaultChecked={this.props.currentValue === false}
                />
                <span className="custom-control-description">No</span>
                <span className="custom-control-indicator mr-0 ml-2" />
              </label>
            </fieldset>
          </span>
        </div>
      );
    } else if (this.props.type === "dateSelect") {
      return (
        <div className={formGroupClass}>
          <label htmlFor={this.props.id + "Day"}>{this.props.label}</label>
          {this.props.desc ? <p>{this.props.desc}</p> : null}
          <div className="custom-select-group">
            <select
              id={this.props.id + "Day"}
              name={this.props.id + "Day"}
              className="custom-select form-control"
              defaultValue={this.props.value[0]}
            >
              <option disabled="">Day</option>
              {Array.from(Array(32).keys())
                .splice(1)
                .map((day) => {
                  return (
                    <option value={("0" + day).substr(-2)} key={day}>
                      {("0" + day).substr(-2)}
                    </option>
                  );
                })}
            </select>
            <span className="p-2">/</span>
            <select
              id={this.props.id + "Month"}
              name={this.props.id + "Month"}
              className="custom-select form-control"
              defaultValue={this.props.value[1]}
            >
              <option disabled="">Month</option>
              <option>January</option>
              <option>February</option>
              <option>March</option>
              <option>April</option>
              <option>May</option>
              <option>June</option>
              <option>July</option>
              <option>August</option>
              <option>September</option>
              <option>October</option>
              <option>November</option>
              <option>December</option>
            </select>
            <span className="p-2">/</span>
            <select
              id={this.props.id + "Year"}
              name={this.props.id + "Year"}
              className="custom-select form-control"
              defaultValue={this.props.value[2]}
            >
              <option disabled="">Year</option>
              {Array.from(Array(parseInt(this.props.numYears, 10) + 2).keys())
                .splice(1 + parseInt(this.props.ageOffset, 10))
                .map((year) => {
                  return (
                    <option key={year}>
                      {new Date().getFullYear() - year + 1}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
      );
    }

    switch (this.props.type) {
      case "number":
      case "email":
      case "text":
        inputTag = (
          <React.Fragment>
            <input
              type={this.props.type}
              className="form-control"
              id={this.props.id}
              autoComplete={this.props.autocomplete}
              value={
                this.props.updateValue ? this.props.currentValue : undefined
              }
              defaultValue={
                this.props.updateValue ? undefined : this.props.currentValue
              }
              onChange={this.props.updateValue}
              onBlur={this.props.updateValueBlur}
              name={this.props.id}
              aria-describedby={this.props.id + "Help"}
              onPaste={(e) =>
                this.props.preventPaste ? e.preventDefault() : true
              }
            />
            {this.props.inputTooltip ? (
              <div className="input-tooltip">
                <p>{this.props.inputTooltip}</p>
              </div>
            ) : null}
            <span id={this.props.id + "Help"} className="sr-only">
              {this.props.ariaLabel}
            </span>
          </React.Fragment>
        );
        break;
      case "select":
        inputTag = (
          <React.Fragment>
            <select
              className="form-control custom-select"
              id={this.props.id}
              name={this.props.id}
              value={this.props.currentValue}
              onChange={this.props.updateValue}
              aria-describedby={this.props.id + "Help"}
            >
              {this.props.values.map((value) => {
                return <option key={value}>{value}</option>;
              })}
            </select>
            {this.props.inputTooltip ? (
              <div className="input-tooltip">
                <p>{this.props.inputTooltip}</p>
              </div>
            ) : null}
            <span id={this.props.id + "Help"} className="sr-only">
              {this.props.ariaLabel}
            </span>
          </React.Fragment>
        );
        break;
      case "password":
        inputTag = (
          <React.Fragment>
            <div className="form-control form-control-password">
              <PasswordField
                changePasswordCallback={this.props.updateValue}
                blurPasswordCallback={this.props.onBlurPasswordCallback}
                passwordid={this.props.id}
                preventPaste={this.props.preventPaste}
              />
            </div>
            {this.props.inputTooltip ? (
              <div className="input-tooltip">
                <p>{this.props.inputTooltip}</p>
              </div>
            ) : null}
            <span id={this.props.id + "Help"} className="sr-only">
              {this.props.ariaLabel}
            </span>
            {/* Please use an attribute called passwordValidator on the FormGroup element if you want this to be displayed */}
            {this.props.passwordValidator ? (
              <div className="password-validator">
                <ul>
                  {this.props.validMinimumCharacters ? (
                    <li>
                      <span className="condition">At least 8 characters</span>
                      <span className="status">
                        {/* Team 1 please write the condition here */}
                        {this.props.validationStatus.minimumCharacters ? (
                          <i className="icon-check-green" />
                        ) : (
                          <i className="icon-cross-orange" />
                        )}
                      </span>
                    </li>
                  ) : null}
                  {this.props.validWithUpperCase ? (
                    <li>
                      <span className="condition">An upper case letter</span>
                      <span className="status">
                        {/* Team 1 please write the condition here */}
                        {this.props.validationStatus.upperCase ? (
                          <i className="icon-check-green" />
                        ) : (
                          <i className="icon-cross-orange" />
                        )}
                      </span>
                    </li>
                  ) : null}
                  {this.props.validWithLowerCase ? (
                    <li>
                      <span className="condition">A lowercase letter</span>
                      <span className="status">
                        {/* Team 1 please write the condition here */}
                        {this.props.validationStatus.lowerCase ? (
                          <i className="icon-check-green" />
                        ) : (
                          <i className="icon-cross-orange" />
                        )}
                      </span>
                    </li>
                  ) : null}
                  {this.props.validWithNumber ? (
                    <li>
                      <span className="condition">A number</span>
                      <span className="status">
                        {/* Team 1 please write the condition here */}
                        {this.props.validationStatus.number ? (
                          <i className="icon-check-green" />
                        ) : (
                          <i className="icon-cross-orange" />
                        )}
                      </span>
                    </li>
                  ) : null}
                  {this.props.validWithspecialCharacters ? (
                    <li>
                      <span className="condition">A special character</span>
                      <span className="status">
                        {/* Team 1 please write the condition here */}
                        {this.props.validationStatus.specialCharacters ? (
                          <i className="icon-check-green" />
                        ) : (
                          <i className="icon-cross-orange" />
                        )}
                      </span>
                    </li>
                  ) : null}
                  {/* Please use an attribute called checkPasswordHistory on the FormGroup element if you want this to be displayed */}
                  {this.props.checkPasswordHistory ? (
                    <li>
                      <span className="condition">
                        A password not used before
                      </span>
                      <span className="status">
                        {/* Team 1 please write the condition here - send the password to API and check if user has already used this password */}
                        {this.props.validationStatus.history ? (
                          <i className="icon-check-green" />
                        ) : (
                          <i className="icon-cross-orange" />
                        )}
                      </span>
                    </li>
                  ) : null}
                </ul>
              </div>
            ) : null}
          </React.Fragment>
        );
        break;

      default:
        break;
    }
    return (
      <div className={formGroupClass}>
        <div className="row hidden-sm-down ml-0">
          <div className="col pl-0">
            <label htmlFor={this.props.id}>{this.props.label}</label>
          </div>
        </div>
        <label className="hidden-md-up" htmlFor={this.props.id}>
          {this.props.label}
        </label>
        {inputTag}
      </div>
    );
  }
}
export default FormGroup;
